import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  showAllGames: {
    id: 'newGames.showAllGames',
    defaultMessage: 'View all games',
  },
  showRecentGames: {
    id: 'newGames.showRecentGames',
    defaultMessage: 'View recent games',
  },
  showFavorites: {
    id: 'newGames.showFavorites',
    defaultMessage: 'View favorite games',
  },
  allTypes: {
    id: 'newGames.allTypes',
    defaultMessage: 'All types',
  },
  allProviders: {
    id: 'newGames.allProviders',
    defaultMessage: 'All providers',
  },
  popular: {
    id: 'newGames.popular',
    defaultMessage: 'Popular',
  },
  showAll: {
    id: 'newGames.showAll',
    defaultMessage: 'View all',
  },
  searchGame: {
    id: 'newGames.searchGame',
    defaultMessage: 'Search by game name',
  },
  goBackToGames: {
    id: 'newGames.goBackToGames',
    defaultMessage: 'Back to games',
  },
  allGamesForCategory: {
    id: 'newGames.allGamesForCategory',
    defaultMessage: 'All games for category',
  },
  favoriteGames: {
    id: 'newGames.favoriteGames',
    defaultMessage: 'Favorite games',
  },
  recentGames: {
    id: 'newGames.recentGames',
    defaultMessage: 'Recent games',
  },
  recentGamesNot: {
    id: 'newGames.recentGamesNot',
    defaultMessage: 'You have no recent games',
  },
  favoriteGamesNot: {
    id: 'newGames.favoriteGamesNot',
    defaultMessage: 'You have no favorite games',
  },
  showMore: {
    id: 'newGames.showMore',
    defaultMessage: 'Show more',
  },
  allGames: {
    id: 'newGames.allGames',
    defaultMessage: 'All games',
  },
  new: {
    id: 'newGames.New',
    defaultMessage: 'New',
  },
  hot: {
    id: 'newGames.Hot',
    defaultMessage: 'Hot',
  },
})



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/GamesPageNewLayout/messages.js